module.exports = __webpack_public_path__ + "img/logo_login.6b20991c.png";